
import { RegistrationInfoService } from './registrationInfo'
import { IProvider } from './provider.types'
import { IGrantServices, GrantService, ICommunicationServices, CommunicationService, AgreementService, MonitorService } from './grants'
import { ApplicationService, SummaryServices, LogframeworkService, BudgetService } from './application'
import { ConceptNoteService } from './conceptNote'
import { DashboardService } from './dashboard';
import { GMSDashboardService } from './gmsdashboard';
import { ReviewService } from './review';
import { EntityService, TemplateMgrService,ArchiveService,UsefulDocService} from './admin';
import { PDFReportService, IndicatorReportService, ExternalReviewReport, ReviewReportService, AllocationReportService, ImplementationProgressReportService,
  DuedeligenceReportService, BugetReportService, MultipleReviewReport,CombinedBudgetAndDDAsessment,finalTechnicalReport, IBudgetReportService } from './reports'
import { ReviewInternalService } from './review.internal';
import { DocumetUploadService, CommentService, RevisionService, WorkflowService } from './common'
import { LanguageManagerService } from './languagemanager';
import { DateFormatService } from './date';
import { IFormatServices, FormatServices } from './formats';
import { MigrationService } from './migrationimport';
import {CommiunicationReportsService} from './commiunicationreport';
import {CallChecklistService} from './callchecklist';
import { ContactService } from './contact'
import { GrantAmendmentService } from './grantAmendment'

export const provider = (): IProvider => ({
  application: new ApplicationService(),
  conceptNote: new ConceptNoteService(),
  registrationInfo: new RegistrationInfoService(),
  dashboard: new DashboardService(),
  logframework: new LogframeworkService(),
  summary: new SummaryServices(),
  review: new ReviewService(),
  entity: new EntityService(),
  template: new TemplateMgrService(),
  reviewinternal: new ReviewInternalService(),
  document: new DocumetUploadService(),
  pdf: new PDFReportService(),
  indicatorReport: new IndicatorReportService(),
  reviewPdf: new ReviewReportService(),
  tagReviewReport: new ExternalReviewReport(),
  languageManager: new LanguageManagerService(),
  dateFormat: new DateFormatService(),
  grant: new GrantService(),
  dueDeligancePdf: new DuedeligenceReportService(),
  budgetAssessmentPdf: new BugetReportService(),
  agreement: new AgreementService(),
  monitor: new MonitorService(),
  format: new FormatServices(),
  comment: new CommentService(),
  revision: new RevisionService(),
  MultipleReports:new MultipleReviewReport(),
  budget: new BudgetService(),
  AsessmentPrint: new CombinedBudgetAndDDAsessment(),
  worflow: new WorkflowService(),
  gmsdashboard: new GMSDashboardService(),
  TechnicalReoprt:new finalTechnicalReport(),
  allocationReport: new AllocationReportService(),
  implentationProgressReport: new ImplementationProgressReportService(),
  archive:new ArchiveService(),
  usefulDocs:new UsefulDocService(),
  migration: new MigrationService(),
  communication: new CommunicationService(),
  commiunicationReport: new CommiunicationReportsService(),
  callChecklist: new CallChecklistService(),
  contact: new ContactService(),
  grantAmendment: new GrantAmendmentService()
})